import { render } from "./Category.html?vue&type=template&id=6169859c&scoped=true&ts=true"
import script from "./Category.ts?vue&type=script&lang=ts"
export * from "./Category.ts?vue&type=script&lang=ts"

import "./Category.css?vue&type=style&index=0&id=6169859c&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6169859c"]])

export default __exports__